import Nullstack from 'nullstack';
export default function IconSunLow({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sun-low",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h.01"
  }), "   ", Nullstack.element("path", {
    d: "M12 4v.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 12h.01"
  }), "   ", Nullstack.element("path", {
    d: "M12 20v.01"
  }), "   ", Nullstack.element("path", {
    d: "M6.31 6.31l-.01 -.01"
  }), "   ", Nullstack.element("path", {
    d: "M17.71 6.31l-.01 -.01"
  }), "   ", Nullstack.element("path", {
    d: "M17.7 17.7l.01 .01"
  }), "   ", Nullstack.element("path", {
    d: "M6.3 17.7l.01 .01"
  }), " ");
}